export default __webpack_public_path__ + "static/Blind-angels-jose-joaquin-video-thumbnail-9316e305dfc2c728827ee96b07dc90b4.png";